import { isNumber, isString } from 'lodash';
import {
  CRM_STATES,
  CRM_LOCALSTORAGE_LAST_STATE,
  CRM_LOCALSTORAGE_LAST_STATE_CHANGED_AT,
} from '../../consts/general';

export const localStorageStatus = localStorage.getItem(
  CRM_LOCALSTORAGE_LAST_STATE
);

export const localStorageStatusChangedAt = localStorage.getItem(
  CRM_LOCALSTORAGE_LAST_STATE_CHANGED_AT
);

export const shouldUseLocalStorageCRMStatus = (() => {
  const lastStatus = localStorageStatus;
  const lastUpdate = localStorageStatusChangedAt;

  if (!lastStatus || !lastUpdate) {
    return false;
  }

  const today = Date.now();
  const oneDayMs = 24 * 60 * 60 * 1000;
  const daysDiff = (today - lastUpdate) / oneDayMs;

  return daysDiff < 1;
})();

export const parseCurrentManager = ({ person }) => {
  if (!person) {
    return null;
  }

  const { id } = person;
  if (!id || !(isNumber(id) || isString(id))) {
    return null;
  }

  return {
    name: person.full_name,
    id: String(id),
    number: person.sip_extension,
    avatarUrl: person.avatar_url,
    isOperator: person.is_sip_user,
    isSupervisor: person.sip_supervisor,
    operatorState: CRM_STATES.OFFLINE,
    manualState: CRM_STATES.OFFLINE,
    remoteState: null,
    skillGroupIds: person.skill_group_ids,
    activeTicketsCount: person.active_tickets_count || 0,
    reservedTicketsCount: person.reserved_tickets_count || 0,
    isAlfaTravelManager: person.alfa_travel_manager,
  };
};
